import EmptyTemplatesImage from "@/assets/images/empty-templates.svg?react";
import {
  EmptyContainer,
  EmptyText,
  EmptyTextContainer,
  EmptyTextSubtitle,
} from "@/components/styling/empty";
import { useTabPageStore } from "@/components/layout/components/tab-bar/use-tab-page-store";
import { MDSButton, MDSButtonVariant } from "@/mds";

export const TemplatesListPageEmpty = () => {
  const page = useTabPageStore("templatesListPage");

  return (
    <EmptyContainer>
      <EmptyTemplatesImage />
      <EmptyTextContainer>
        <EmptyText>No templates yet</EmptyText>
        <EmptyTextSubtitle>Use templates to format your notes consistently</EmptyTextSubtitle>
      </EmptyTextContainer>
      <MDSButton
        variant={MDSButtonVariant.Contrast}
        onClick={async () => await page.handleCreateNewTemplate()}
      >
        Create template
      </MDSButton>
    </EmptyContainer>
  );
};
